var _circle, _circle2, _path, _path2, _path3, _circle3, _ellipse, _ellipse2, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCosmosAtomLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cosmos-atom-logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9624",
    "data-name": "Ellipse 9624",
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#2e3148"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9625",
    "data-name": "Ellipse 9625",
    cx: 13.275,
    cy: 13.275,
    r: 13.275,
    transform: "translate(9.603 9.603)",
    fill: "#1b1e36"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_102250",
    "data-name": "Path 102250",
    d: "M1012.7,159.47c-2.469,0-4.472,8.957-4.472,20.007s2,20.007,4.472,20.007,4.472-8.957,4.472-20.007S1015.172,159.47,1012.7,159.47Zm.309,38.885a.354.354,0,0,1-.565.094,10.625,10.625,0,0,1-1.706-3.766c-1.989-6.4-1.516-20.148-1.516-20.148.935-10.913,2.636-13.491,3.214-14.063a.353.353,0,0,1,.453-.037c.84.6,1.544,3.083,1.544,3.083a58.812,58.812,0,0,1,1.891,14.97,77.685,77.685,0,0,1-1.042,13.369C1014.337,197.224,1013.011,198.355,1013.011,198.355Z",
    transform: "translate(-989.777 -156.551)",
    fill: "#6f7390"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_102251",
    "data-name": "Path 102251",
    d: "M331.359,669.321c-1.23-2.143-9.995.578-19.584,6.077s-16.353,11.693-15.124,13.835,9.995-.578,19.584-6.077,16.353-11.693,15.124-13.835Zm-33.574,19.618c-.471-.059-.364-.446-.364-.446a10.643,10.643,0,0,1,2.415-3.354c4.565-4.912,16.725-11.341,16.725-11.341,9.93-4.62,13.014-4.425,13.8-4.21a.353.353,0,0,1,.256.377c-.094,1.025-1.907,2.873-1.907,2.873a58.717,58.717,0,0,1-12.04,9.093,77.547,77.547,0,0,1-12.115,5.749c-5.126,1.847-6.767,1.259-6.767,1.259h0Z",
    transform: "translate(-291.08 -656.352)",
    fill: "#6f7390"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_102252",
    "data-name": "Path 102252",
    d: "M333.554,685.845c1.239-2.137-5.508-8.36-15.063-13.9s-18.32-8.294-19.558-6.154,5.508,8.361,15.069,13.9S332.316,687.987,333.554,685.845Zm-33.8-19.228a.358.358,0,0,1,.2-.538,10.619,10.619,0,0,1,4.113.413c6.537,1.489,18.193,8.79,18.193,8.79,8.974,6.28,10.351,9.046,10.557,9.831a.353.353,0,0,1-.2.411c-.936.428-3.442-.21-3.442-.21a58.866,58.866,0,0,1-13.9-5.866,77.185,77.185,0,0,1-11.04-7.6c-4.171-3.512-4.484-5.224-4.484-5.224Z",
    transform: "translate(-293.318 -652.893)",
    fill: "#6f7390"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9626",
    "data-name": "Ellipse 9626",
    cx: 2.354,
    cy: 2.354,
    r: 2.354,
    transform: "translate(20.525 20.525)",
    fill: "#b7b9c8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9627",
    "data-name": "Ellipse 9627",
    cx: 1.365,
    cy: 1.412,
    rx: 1.365,
    ry: 1.412,
    transform: "translate(31.164 12.428)",
    fill: "#b7b9c8"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9628",
    "data-name": "Ellipse 9628",
    cx: 1.365,
    cy: 1.412,
    rx: 1.365,
    ry: 1.412,
    transform: "translate(8.756 17.23)",
    fill: "#b7b9c8"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9629",
    "data-name": "Ellipse 9629",
    cx: 1.365,
    cy: 1.412,
    rx: 1.365,
    ry: 1.412,
    transform: "translate(18.736 34.553)",
    fill: "#b7b9c8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosmosAtomLogo);
export default __webpack_public_path__ + "static/media/cosmos-atom-logo.eaaa0e9cfab4b10b3eba750d39c55e5e.svg";
export { ForwardRef as ReactComponent };